import React from 'react';
import { twMerge } from 'tailwind-merge';

import ControlsRewind from '@videoblocks/react-icons/ControlsRewind';

export interface AudioPlayerRewindButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
}

export const AudioPlayerRewindButton = ({ className, ...rest }: AudioPlayerRewindButtonProps): JSX.Element => {
    return (
        <button aria-label="audio player rewind button" title="audio player rewind button" {...rest}>
            <ControlsRewind className={twMerge('w-6 h-6 fill-current hover:cursor-pointer', className)} />
        </button>
    );
};
